<div
  class="meal-menu-mgmt flex flex-col min-h-[calc(100vh-100px)] w-full bg-[#F7FAFC] font-['Archivo',sans-serif] px-[24px] md:px-[32px] lg:px-[40px] pt-[24px] pb-[32px]">
  <div *ngIf="isInitialLoading" class="flex flex-col items-center justify-center w-full py-[80px] gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isInitialLoading">
    <div
      class="meal-menu-mgmt__panel w-full bg-white rounded-[12px] border border-[#EAECF0] shadow-[0_1px_3px_rgba(16,24,40,0.08),0_1px_2px_rgba(16,24,40,0.06)] p-[24px] flex flex-col gap-[20px]">
      <div class="flex flex-row flex-wrap items-center justify-between gap-[16px]">
        <div class="flex flex-row items-center gap-[16px]">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-[8px] box-border h-[44px] px-[16px] rounded-[16px] border border-[#D0D5DD] bg-white text-[#101828] text-[16px] font-semibold leading-[20px] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="goBack()"
            aria-label="Back">
            <svg
              class="w-5 h-5 shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M20 12H4M4 12L10 18M4 12L10 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Back</span>
          </button>
          <h1 class="meal-menu-mgmt__title">
            Meal Menu
          </h1>
        </div>

        <div class="flex flex-row flex-wrap items-center gap-[10px] justify-end">
          <div class="relative w-[220px]">
            <input
              type="search"
              class="w-full h-[40px] rounded-[8px] border border-[#D0D5DD] bg-white pl-[12px] pr-[40px] font-['Archivo',sans-serif] text-[14px] font-normal leading-[20px] text-[#111215] placeholder:text-[#98A2B3] outline-none focus:border-[#F26F24]"
              placeholder="Search..."
              [ngModel]="searchText"
              (ngModelChange)="onSearchInput($event)"
              aria-label="Search meal menu" />
            <img
              src="assets/icons/search_md.svg"
              alt=""
              class="absolute right-[12px] top-1/2 -translate-y-1/2 w-[16px] h-[16px] opacity-60 pointer-events-none" />
          </div>

          <button
            type="button"
            class="meal-menu-mgmt__toolbar-btn inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="onDownload()">
            <img src="assets/icons/download.svg" alt="" class="w-[16px] h-[16px]" />
            Download
          </button>

          <button
            type="button"
            class="meal-menu-mgmt__toolbar-btn inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#F26F24] bg-white text-[#F26F24] cursor-pointer hover:bg-[#FFF3EA]"
            (click)="openBulkUploadModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M12 16V4M12 4l-4 4M12 4l4 4" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke-linecap="round" />
            </svg>
            Bulk Upload
          </button>
        </div>
      </div>

      <div *ngIf="errorMessage" class="text-red-600 text-[14px] font-['Archivo',sans-serif]">
        {{ errorMessage }}
      </div>

      <div class="meal-menu-mgmt__table w-full overflow-x-auto">
        <NiTable
          *ngIf="!errorMessage"
          [columns]="columns"
          [data]="filteredList"
          trackByKey="id"
          [pagination]="false"
          emptyMessage="No meal menu items found."
        >
          <ng-template niTableCell="day" let-row="row">
            <span class="meal-menu-mgmt__cell meal-menu-mgmt__cell--day">{{ row.day }}</span>
          </ng-template>

          <ng-template niTableCell="vegHotMeal" let-row="row">
            <span class="meal-menu-mgmt__cell" [title]="row.vegHotMeal">{{ row.vegHotMeal }}</span>
          </ng-template>

          <ng-template niTableCell="vegColdMeal" let-row="row">
            <span class="meal-menu-mgmt__cell" [title]="row.vegColdMeal">{{ row.vegColdMeal }}</span>
          </ng-template>

          <ng-template niTableCell="nonVegHotMeal" let-row="row">
            <span class="meal-menu-mgmt__cell" [title]="row.nonVegHotMeal">{{ row.nonVegHotMeal }}</span>
          </ng-template>

          <ng-template niTableCell="nonVegColdMeal" let-row="row">
            <span class="meal-menu-mgmt__cell" [title]="row.nonVegColdMeal">{{ row.nonVegColdMeal }}</span>
          </ng-template>

          <ng-template niTableCell="action" let-row="row">
            <button
              type="button"
              class="inline-flex items-center justify-center w-[32px] h-[32px] rounded-[6px] border-0 bg-transparent cursor-pointer hover:bg-[#F2F4F7]"
              (click)="openEdit(row)"
              aria-label="Edit meal">
              <img src="assets/icons/edit05.svg" alt="" class="w-[16px] h-[16px]" />
            </button>
          </ng-template>
        </NiTable>
      </div>
    </div>
  </ng-container>

  <div
    *ngIf="isEditOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-[16px]"
    (click)="closeEdit()">
    <div
      class="w-full max-w-[560px] max-h-[90vh] overflow-y-auto rounded-[12px] bg-white shadow-[0_12px_40px_rgba(16,24,40,0.18)] p-[24px] flex flex-col gap-[16px]"
      role="dialog"
      aria-label="Edit meal"
      (click)="$event.stopPropagation()">
      <h2 class="m-0 text-[20px] font-bold text-[#101828]">Edit Meal — {{ editingRow?.day }}</h2>

      <label class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium leading-[18px] text-[#444955]">Veg Hot Meal</span>
        <input
          type="text"
          class="h-[44px] rounded-[8px] border border-[#D0D5DD] px-[14px] text-[14px] font-medium leading-[20px] text-[#333740] outline-none focus:border-[#F26F24]"
          [(ngModel)]="editVegHotMeal" />
      </label>

      <label class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium leading-[18px] text-[#444955]">Veg Cold Meal</span>
        <input
          type="text"
          class="h-[44px] rounded-[8px] border border-[#D0D5DD] px-[14px] text-[14px] font-medium leading-[20px] text-[#333740] outline-none focus:border-[#F26F24]"
          [(ngModel)]="editVegColdMeal" />
      </label>

      <label class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium leading-[18px] text-[#444955]">Non-Veg Hot Meal</span>
        <input
          type="text"
          class="h-[44px] rounded-[8px] border border-[#D0D5DD] px-[14px] text-[14px] font-medium leading-[20px] text-[#333740] outline-none focus:border-[#F26F24]"
          [(ngModel)]="editNonVegHotMeal" />
      </label>

      <label class="flex flex-col gap-[6px]">
        <span class="text-[14px] font-medium leading-[18px] text-[#444955]">Non-Veg Cold Meal</span>
        <input
          type="text"
          class="h-[44px] rounded-[8px] border border-[#D0D5DD] px-[14px] text-[14px] font-medium leading-[20px] text-[#333740] outline-none focus:border-[#F26F24]"
          [(ngModel)]="editNonVegColdMeal" />
      </label>

      <div class="flex flex-row items-center justify-end gap-[12px] pt-[8px]">
        <button
          type="button"
          class="h-[40px] px-[18px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
          [disabled]="isSavingEdit"
          (click)="closeEdit()">
          Cancel
        </button>
        <button
          type="button"
          class="h-[40px] px-[22px] rounded-[8px] border-0 bg-[#F26F24] text-white text-[14px] font-semibold cursor-pointer hover:bg-orange-600 disabled:opacity-60"
          [disabled]="isSavingEdit"
          (click)="saveEdit()">
          {{ isSavingEdit ? 'Saving…' : 'Save' }}
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="isBulkUploadOpen"
    class="fixed inset-0 z-40 bg-black/30"
    (click)="closeBulkUploadModal()"></div>

  <div
    *ngIf="isBulkUploadOpen"
    class="fixed left-1/2 top-1/2 z-50 w-[calc(100%-32px)] max-w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-[12px] border border-[#EAECF0] bg-white shadow-[0_20px_40px_rgba(16,24,40,0.16)]"
    role="dialog"
    aria-modal="true"
    aria-labelledby="meal-bulk-upload-title"
    (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between px-[24px] py-[18px] border-b border-[#EAECF0]">
      <h2 id="meal-bulk-upload-title" class="m-0 text-[20px] font-bold text-[#101828]">Bulk Upload</h2>
      <button
        type="button"
        class="w-[36px] h-[36px] rounded-[8px] border-0 bg-transparent cursor-pointer text-[22px] leading-none text-[#475467] hover:bg-[#F2F4F7]"
        (click)="closeBulkUploadModal()"
        aria-label="Close bulk upload">
        ×
      </button>
    </div>

    <div class="px-[24px] py-[20px] flex flex-col gap-[20px]">
      <p class="m-0 text-[14px] leading-[20px] text-[#667085]">
        Download the template, fill Date / VegHotMeal / VegColdMeal / NonVegHotMeal / NonVegColdMeal
        (Date as MM/DD/YYYY, e.g. 09/27/2026), then upload. Each date updates that weekday’s menu.
        Replace the MM/DD/YYYY example in the Date column with a real date.
      </p>

      <div class="rounded-[10px] border border-[#EAECF0] bg-[#F9FAFB] px-[16px] py-[14px] flex flex-col gap-[10px]">
        <span class="text-[14px] font-semibold text-[#101828]">1. Download template</span>
        <button
          type="button"
          class="inline-flex items-center justify-center gap-[8px] self-start h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
          (click)="downloadBulkTemplate()">
          <img src="assets/icons/download.svg" alt="" class="w-[16px] h-[16px]" />
          Download Template
        </button>
      </div>

      <div class="rounded-[10px] border border-[#EAECF0] bg-[#F9FAFB] px-[16px] py-[14px] flex flex-col gap-[10px]">
        <span class="text-[14px] font-semibold text-[#101828]">2. Upload completed file</span>
        <span class="text-[13px] leading-[18px] text-[#667085]">
          Accepts .csv, .xlsx, or .xls. Columns: Date (MM/DD/YYYY), HotMeal, ColdMeal.
        </span>
        <div class="flex flex-row flex-wrap items-center gap-[10px]">
          <button
            type="button"
            class="inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#F26F24] bg-white text-[#F26F24] text-[14px] font-semibold cursor-pointer hover:bg-[#FFF3EA]"
            (click)="triggerBulkFilePicker()">
            Choose File
          </button>
          <span class="text-[13px] text-[#475467]">
            {{ bulkSelectedFileName || 'No file selected' }}
          </span>
        </div>
        <input
          #bulkFileInput
          type="file"
          class="hidden"
          accept=".csv,.xlsx,.xls,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          (change)="onBulkFileSelected($event)" />
      </div>

      <div *ngIf="bulkErrorMessage" class="text-red-600 text-[13px] leading-[18px]">
        {{ bulkErrorMessage }}
      </div>
      <div *ngIf="bulkSuccessMessage" class="text-green-700 text-[13px] leading-[18px]">
        {{ bulkSuccessMessage }}
      </div>
      <ul *ngIf="bulkRowErrors.length" class="m-0 pl-[18px] flex flex-col gap-[4px] text-[13px] text-[#B42318]">
        <li *ngFor="let err of bulkRowErrors">
          Row {{ err.row }}{{ err.day ? ' (' + err.day + ')' : '' }}: {{ err.message }}
        </li>
      </ul>
    </div>

    <div class="px-[24px] py-[16px] border-t border-[#EAECF0] flex flex-row items-center justify-end gap-[12px]">
      <button
        type="button"
        class="h-[40px] px-[18px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[14px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
        [disabled]="isBulkUploading"
        (click)="closeBulkUploadModal()">
        Cancel
      </button>
      <button
        type="button"
        class="h-[40px] px-[22px] rounded-[8px] border-0 bg-[#F26F24] text-white text-[14px] font-semibold cursor-pointer hover:bg-orange-600 disabled:opacity-60 disabled:cursor-not-allowed"
        [disabled]="isBulkUploading || !bulkSelectedFile"
        (click)="submitBulkUpload()">
        {{ isBulkUploading ? 'Uploading…' : 'Upload' }}
      </button>
    </div>
  </div>
</div>
